export default "__VITE_ASSET__DJYHNMhS__"